import { Control, Controller, FieldValues, Path } from 'react-hook-form'

import { dateTimeToField, dateToField } from '@/common/form/date'
import { registerDateOption } from '@/common/form/register'

import TextField, { FieldType, TextBoxSize } from '@/components/view/atoms/textfield/TextField'

export const FormDateTextFieldType = {
  DATE: 'date',
  TIME: 'time',
  DATETIME: 'datetime'
} as const

export type FormDateTextFieldType = (typeof FormDateTextFieldType)[keyof typeof FormDateTextFieldType]

interface Props<T extends FieldValues> {
  type?: FormDateTextFieldType
  fieldType?: FieldType
  size?: TextBoxSize
  error?: boolean
  placeholder?: string
  control: Control<T>
  name: Path<T>
  disabled?: boolean
}

const FormDateTextField = <T extends FieldValues>({
  type = FormDateTextFieldType.DATETIME,
  fieldType = FieldType.DEFAULT,
  size = TextBoxSize.MEDIUM,
  placeholder,
  control,
  name,
  disabled = false
}: Props<T>) => {
  // Use control not register for reseting datetime input with value props
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <TextField
          fieldType={!!fieldState.error?.message ? FieldType.SEMI_REQUIRED : fieldType}
          type={
            type == FormDateTextFieldType.DATETIME
              ? 'datetime-local'
              : type == FormDateTextFieldType.TIME
                ? 'time'
                : 'date'
          }
          value={
            field.value
              ? type == FormDateTextFieldType.DATETIME
                ? dateTimeToField(field.value)
                : type == FormDateTextFieldType.TIME
                  ? field.value
                  : dateToField(field.value)
              : ''
          }
          size={size}
          name={field.name}
          onChange={(e) => {
            field.onChange(
              type != FormDateTextFieldType.TIME ? registerDateOption.setValueAs(e.target.value) : e.target.value
            )
          }}
          onBlur={field.onBlur}
          inputRef={field.ref}
          disabled={field.disabled || disabled}
          error={!!fieldState.error?.message}
          placeholder={placeholder}
          required={fieldType == FieldType.REQUIRED}
        />
      )}
    />
  )
}

export default FormDateTextField
